import { AgsMatrixFactory } from "ags/setup/factories/ags-matrix-factory";
import { AbstractMatrixComponent } from "slotworks/components/matrix/abstract-matrix-component";
import { AlternatingBlankReelSpinnerResultBuffer } from "slotworks/components/matrix/reel/transition-behaviours/spin/alternating-blanks-reel-spinner-result-buffer";
import { ReelSpinner } from "slotworks/components/matrix/reel/transition-behaviours/spin/reel-spinner";
import { SpinReelTransition } from "slotworks/components/matrix/reel/transition-behaviours/spin/spin-reel-transition";
import { LandPulseSymbolBehaviour } from "slotworks/components/matrix/symbol/behaviours/land-pulse-symbol-behaviour";
import { ThemeWinCyclePulseSymbolBehaviour } from "behaviours/theme-win-cycle-pulse-symbol-behaviour";
import { ThemeAlwaysAnimateOnLandBehaviour } from "behaviours/theme-always-animate-land-behaviour";
import { ThemeAnimateBehaviour } from "behaviours/theme-animate-behaviour";
import { ThemeAnimateWinsComponent } from "components/theme-animate-wins-component";
import { Components } from "appworks/components/components";
import { ThemeCelebrateWinComponent } from "components/theme-celebrate-win-component";
import { ThemeTintDimSymbolBehaviour } from "behaviours/theme-tint-dim-symbol-behavior";


export class ThemeMatrixFactory extends AgsMatrixFactory {
    protected createTransition(matrix: AbstractMatrixComponent) {

        ReelSpinner.addStageSet({
            id: "default",
            spin: [this.spinStages],
            skip: [this.skipStages],
            anticipate: [this.anticipationStages],
            quickSpin: [this.quickSpinStages]
        });

        ReelSpinner.setStageSet("default");

        ReelSpinner.bufferType = AlternatingBlankReelSpinnerResultBuffer;
        matrix.setTransition(new SpinReelTransition());
    }

    protected addSymbolBehaviours(matrix: AbstractMatrixComponent) {
        matrix.addDefaultSymbolBehaviour((symbol) => new ThemeTintDimSymbolBehaviour(symbol));
        matrix.addDefaultSymbolBehaviour((symbol) => new LandPulseSymbolBehaviour(symbol), ["X", "Y", "Z"]);
        matrix.addDefaultSymbolBehaviour((symbol) => new ThemeWinCyclePulseSymbolBehaviour(symbol, Components.get(ThemeCelebrateWinComponent).config.lineWaitTime));
        matrix.addDefaultSymbolBehaviour((symbol) => new ThemeAnimateWinsComponent.AgsAnimateBehaviourType(symbol), ["X", "Y", "Z"]);
        // matrix.addDefaultSymbolBehaviour((symbol) => new ThemeAlwaysAnimateOnLandBehaviour(symbol), ["A2", "A5", "B3", "B4", "C2", "C5", "M3", "M4", "M5", "N3", "N4", "N5"]);
        // matrix.addDefaultSymbolBehaviour((symbol) => new ThemeAnimateBehaviour(symbol), ["A2", "A5", "B3", "B4", "C2", "C5", "M3", "M4", "M5", "N3", "N4", "N5"]);
    }
}